"use strict";
/*
      coverGuide指令
      hmtl:<cover-guide></cover-guide>,
      css:
      js:
      参数：
 */
angular.module("coverGuideModule", [])
    .directive("coverGuide", ['$timeout', "trsHttpService", function($timeout, trsHttpService) {
        return {
            restrict: 'E',
            link: function(scope, element, attr) {
                var lazycoverGuide = function() {
                    require(['./lib/intro/intro'], function(introJs) {
                        LazyLoad.css(['./lib/intro/introjs.css'], function() {
                            introJs().start();
                            newVersion = false;
                        });
                    });
                };
                var newVersion = false;
                var clientVersion = parseInt(element.attr("iWoVersion"));
                var param = '{"iWoVersion":+clientVersion+"}"';

                trsHttpService.httpServer("/lib/intro/iWo.json", param, "get").then(function(data) {
                    var serverVersion = parseInt(data.iWoVersion);
                    if (serverVersion < clientVersion || (isNaN(serverVersion))) {
                        newVersion = true;
                        //服务器版本低，向服务器写入客户端版本
                        trsHttpService.httpServer("/lib/intro/iWo.json", param, "post");
                    } else {
                        newVersion = false;
                    }
                    if (newVersion) {
                        if (typeof define === 'function' && define.amd) { // AMD
                            $timeout(function() {
                                lazycoverGuide();
                            }, 1000);
                        } else {
                            LazyLoad.js(['./lib/requirejs/require.js'], function() {
                                $timeout(function() {
                                    lazycoverGuide();
                                }, 1000);
                            });
                        }
                        newVersion = false;
                    }
                });
            }
        };
    }]);